import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export default function Testimonials(handle, {
    paginationHandle,
    navigationHandle,
    prevHandle,
    nextHandle,
}) {

    const pagination = handle.querySelector(paginationHandle);
    const navigation = handle.querySelector(navigationHandle);
    const prev = handle.querySelector(prevHandle);
    const next = handle.querySelector(nextHandle);

    const swiper = new Swiper('.swiper', {
        modules: [Navigation, Pagination],
        loop: true,
        navigation: {
            prevEl: prev,
            nextEl: next,
        },
        pagination: {
            el: pagination,
            type: 'fraction',
        },        
    });
}
